import { Component, EventEmitter, inject, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CompilationModel, ProjectRemark, ProjectRemarkItem } from '../../../../../../@models/erp/compilation';
import { AuthGuardService } from '../../../../../../@core/service/auth-guard.service';
import { ApiService } from '../../../../../../@core/service/api.service';

@Component({
  selector: 'ngx-profit-margin-remark',
  templateUrl: './profit-margin-remark.component.html',
  styleUrls: ['./profit-margin-remark.component.scss'],
})
export class ProfitMarginRemarkComponent implements OnChanges {

  auth = inject(AuthGuardService);
  api = inject(ApiService);
  
  @Input() compilation: CompilationModel;
  @Input() print = false;

  categoryOptions = ['Summary', 'Technical project description', 'Admin updates', 'Commercial updates', 'Technical updates']
    .map(m => ({ id: m, name: m }));

  constructor() {}
  
  ngOnChanges(changes: SimpleChanges) {
    // console.log('cahnges', changes, this.compilation.projectRemark.items);
    if (changes.compilation?.currentValue) {
      if (!this.compilation.projectRemark) {
        this.compilation.projectRemark = new ProjectRemark();
      }
      if (this.compilation && !this.compilation.projectRemark?.items) {
        this.compilation.projectRemark.items = [];
      }
    }
  }

  addRemark() {
    const newItem = new ProjectRemarkItem();
    newItem.date = new Date();
    newItem.user = this.auth.user?.short ?? '';
    if (!this.compilation.projectRemark?.items) {
      this.compilation.projectRemark = new ProjectRemark()
      this.compilation.projectRemark.items =[];
    }
    this.compilation.projectRemark?.items?.unshift(newItem);
  }

  removeRemark(index: number) {
    this.compilation.projectRemark?.items?.splice(index, 1);
  }

  moveItem(idx: number, up = true) {
    const cut = this.compilation.projectRemark.items.splice(idx, 1);
    this.compilation.projectRemark.items.splice(idx + (up ? -1 : 1), 0, cut[0]);
  }

  filterItems(remark: ProjectRemark) {
    if (this.print) return remark.items.filter(f => !f.inactive);
    return remark.items.sort((a, b) => !a.inactive && !b.inactive ? 0 : a.inactive ? 1 : -1);
  }

  // async saveUpload() {
  //   // const doc = await this.api.loadCompilationByCode(this.compilation?.code);
  //   // doc.projectRemark = this.compilation.projectRemark;
  //   // console.log('------------------------->', doc.projectRemark);
  //   // this.api.saveCompilation(doc);
  // }

}
